export const api = {
    here_country_code: 'AUS',
    here_api_key: 'RnE70LfOuE5nhC0zY0nuGFYCmtWVMWfagZZ7B8H_xaw',
    here_geocode_url: `https://autocomplete.geocoder.ls.hereapi.com/6.2/suggest.json`,
    algolia: {
        app_id: 'KLRTO5LNXG',
        search_api_key: 'a17d607fd06f462d068bc8b49a375074'
    }
};
